import React, { useEffect, useState } from "react";
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { Card, CardContent, Typography, Box, Button, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { ErrorOutline, Description, InsertDriveFile, Event } from "@mui/icons-material";
import UpdatePatientDocumentsDialog from "./UpdatePatientDocumentsDialog";
import { useNavigate } from "react-router-dom";

const PatientDocuments = ({ patientData }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
  const navigate= useNavigate()

  const pid =
    LoginUserType === "Patient" ? LoginUserDetails?.pid : patientData?.pid;
    const navigatePatientDocuments =()=>{
      LoginUserType === "Patient"?
      navigate("/patient/documents"):
      navigate(`/provider/patient/documents/${pid}`)
    }

  useEffect(() => {
    if (!pid) return;

    const apiUrl =
      LoginUserType === "Patient"
        ? `/apis/default/portal/documents`
        : `/apis/default/api/documents`;

    ApiServices.getwitParams(
      apiUrl,
      { pid: pid },
      {
        Authorization: `Bearer ${accessToken}`,
      }
    )
      .then((response) => {
        setDocuments(response.data.documents || []);
      })
      .catch((error) => {
        console.error("Error fetching patient documents:", error);
        setDocuments([]);
      })
      .finally(() => setLoading(false));
  }, [pid, LoginUserType, accessToken]);

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391" }}>
        Documents
      </Typography>
      <Card
        sx={{
          height: "100%",
          p: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          border: "2px solid #028391",
          borderRadius: "12px",
          minHeight:"230px"
        }}
      >
        <CardContent>
          {loading ? (
            <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
              Loading documents...
            </Typography>
          ) : documents.length > 0 ? (
            <List>
              {documents.slice(0, 3).map((doc, index) => (
                
                <>
                 <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt: 1,
                                  p: 1,
                                  borderRadius: "8px",
                                  backgroundColor: "#f5f5f5",
                                }}
                              >
                                {/* File Name */}
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <InsertDriveFile sx={{ fontSize: 20, color: "#028391", mr: 1 }} />
                                  <Typography variant="body2">{doc.document_type || "Unknown Report"}</Typography>
                                </Box>
                
                                {/* Document Date */}
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Event sx={{ fontSize: 20, color: "#028391", mr: 1 }} />
                                  <Typography variant="body2">{doc.updated_at || "No Date"}</Typography>
                                </Box>
                              </Box>
                </>
              ))}
            </List>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
              <ErrorOutline sx={{ fontSize: 40, color: "gray" }} />
              <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
                No Documents Available.
              </Typography>
            </Box>
          )}
          <Button
       sx={{
                  mt: 1,
                  color: "#028391",
                  textTransform: "none",
                  "&:hover": { backgroundColor: "#02839120" },
                }}
        // onClick={() => setOpenDialog(true)}
        onClick= {navigatePatientDocuments}
      >
        Show All & Upload New
      </Button>
        </CardContent>
        
      </Card>

      {/* Show All & Upload New Button */}
      

      {/* Patient Documents Update Dialog */}
      {/* <UpdatePatientDocumentsDialog open={openDialog} handleClose={() => setOpenDialog(false)} documents={documents} patientData={patientData}/> */}
    </Box>
  );
};

export default PatientDocuments;